// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useTenantStore } from "@/providers/TenantContextProvider";
import { useContext } from "react";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
export function useReportsPermissions() {
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    /**
     * Permissions
     */
    var canReadReports = authContext.isAuthorized(true, tenantId, IPermissions.REPORT_READ);
    var canWriteReports = authContext.isAuthorized(true, tenantId, IPermissions.REPORT_WRITE);
    var canCreateReports = authContext.isAuthorized(true, tenantId, IPermissions.REPORT_CREATE);
    var canDeleteReports = authContext.isAuthorized(true, tenantId, IPermissions.REPORT_DELETE);
    var canGenerateReports = authContext.isAuthorized(true, tenantId, IPermissions.REPORT_GENERATE);
    var canPreviewReports = authContext.isAuthorized(true, tenantId, IPermissions.REPORT_PREVIEW);
    var showReportsColumns = authContext.isAuthorized(true, tenantId, IPermissions.EE_REPORTS_COLUMNS);
    /**
     * Permissions
     */
    return {
        canReadReports: canReadReports,
        canWriteReports: canWriteReports,
        canCreateReports: canCreateReports,
        canDeleteReports: canDeleteReports,
        canGenerateReports: canGenerateReports,
        canPreviewReports: canPreviewReports,
        showReportsColumns: showReportsColumns,
    };
}
